// Sonner toast 컴포넌트 — Lumen 디자인
import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }: React.ComponentProps<typeof Sonner>) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-canvly-charcoal group-[.toaster]:border-canvly-ash group-[.toaster]:shadow-none group-[.toaster]:border",
          description: "group-[.toast]:text-canvly-stone",
          actionButton:
            "group-[.toast]:bg-canvly-gold group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-canvly-cream group-[.toast]:text-canvly-stone",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
